import { z } from "zod";

// Criação
const CriarUsuarioSchema = z.object({
  nm_usuario: z.string()
    .nonempty("O nome do usuário é obrigatório.")
    .min(3, "O nome deve ter no mínimo 3 caracteres")
    .max(100, "O nome deve ter no máximo 100 caracteres"),

  tipo: z.enum(["C", "M", "S", "N"], {
    errorMap: () => ({ message: "O tipo deve ser 'C', 'M', 'S' ou 'N'" })
  }),

  senha: z.string()
    .nonempty("A senha é obrigatória ao criar usuário.")
    .min(5, "A senha deve ter no mínimo 5 caracteres"),

  id: z.undefined().optional(), // não pode ter id
});

// Edição
const EditarUsuarioSchema = z.object({
  id: z.string().nonempty("O ID é obrigatório"),

  nm_usuario: z.string()
    .nonempty("O nome do usuário é obrigatório.")
    .min(3, "O nome deve ter no mínimo 3 caracteres")
    .max(100, "O nome deve ter no máximo 100 caracteres"),

  tipo: z.enum(["C", "M", "S", "N"], {
    errorMap: () => ({ message: "O tipo deve ser 'C', 'M', 'S' ou 'N'" })
  }),

  senha: z.string().optional(), // senha opcional na edição
});

// União: ou criação ou edição
export const UsuarioSchema = z.union([CriarUsuarioSchema, EditarUsuarioSchema]);
